import { useContext } from 'react';

import { QSetReviewMainTaskQSetContext } from './qset-review-main-task-qset-provider';

export function useQSetReviewMainTaskQSet() {
  const context = useContext(QSetReviewMainTaskQSetContext);

  if (!context) {
    throw new Error(
      'useQSetReviewMainTaskQSet must be used within a QSetReviewMainTaskQSetContextProvider',
    );
  }

  return context;
}
